import * as yup from 'yup';

export const productReturnFormSchema = yup.object().shape({
  personId: yup.mixed().required('Selecione o fornecedor'),
  productId: yup.mixed().required('Selecione o produto'),
  receiptDate: yup.string().nullable().required('Selecione a data'),
  scheduledQuantity: yup.number().typeError('Informe a quantidade agendada').required('Informe a quantidade agendada'),
  inspectedQuantity: yup
    .number()
    .typeError('Informe a quantidade vistoriada')
    .required('Informe a quantidade vistoriada'),
  returnedQuantity: yup.number().typeError('Informe a quantidade devolvida').required('Informe a quantidade devolvida'),
  stokedQuantity: yup.number().min(0, 'Total não pode menor que zero'),
  returnReceiptReasons: yup.array().required('Selecione o(s) motivo(s)'),
  noteDescription: yup.string(),
  files: yup.mixed().test('required', 'Selecione as imagens', (file) => {
    // return file && file.size <-- u can use this if you don't want to allow empty files to be uploaded;
    if (file) return true;
    return false;
  })
});
